import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import BannerPic from './bannerPic';
import Headline from './headline';
import Info from './info';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_L}>
                {content.bannerPic && content.bannerPic.length > 0 ? (
                    <Chip
                        id="30028"
                        type="struct"
                        title="焦点图广告权益"
                        groupName="焦点图广告权益"
                        position="relative"
                        content={content.bannerPic}>
                        <BannerPic />
                    </Chip>
                ) : (
                    ''
                )}
                <Headline content={content.headline} />
                <div className="clear" />
                <div className={styles.wrapper}>
                    <NoSSR onSSR={<div className={styles.box} />}>
                        <Ad content={content.middleAd} />
                    </NoSSR>
                </div>
                <Info content={content.info} headline={content.headline} />
            </div>
        );
    }
}

export default LeftContent;
